var _path, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#instagram_svg__a)",
    fillRule: "evenodd",
    d: "M37.737 33.826c-.149 3.221-1.662 4.765-4.912 4.912-1.265.058-1.642.07-4.843.07-3.2 0-3.579-.012-4.843-.07-3.255-.148-4.763-1.696-4.912-4.913-.057-1.263-.069-1.642-.069-4.842 0-3.199.013-3.578.07-4.843.15-3.221 1.661-4.763 4.911-4.912 1.265-.056 1.643-.068 4.843-.068s3.578.012 4.843.069c3.247.149 4.765 1.69 4.912 4.912.058 1.264.07 1.644.07 4.843 0 3.2-.013 3.579-.07 4.842Zm2.157-9.783c-.196-4.348-2.613-6.771-6.969-6.97-1.28-.059-1.688-.073-4.942-.073-3.255 0-3.662.014-4.94.072-4.352.199-6.771 2.614-6.97 6.97-.06 1.279-.073 1.686-.073 4.941 0 3.254.013 3.662.072 4.941.199 4.352 2.614 6.77 6.97 6.97 1.279.058 1.686.072 4.941.072 3.254 0 3.662-.014 4.941-.072 4.347-.2 6.772-2.614 6.969-6.97.059-1.279.073-1.687.073-4.941 0-3.255-.014-3.662-.072-4.94Zm-5.514-2.894a1.438 1.438 0 1 0-.001 2.877 1.438 1.438 0 0 0 .001-2.877Zm-10.394 7.835a3.994 3.994 0 1 0 7.988 0 3.994 3.994 0 0 0-7.988 0Zm-2.158 0a6.153 6.153 0 1 1 12.307 0 6.153 6.153 0 0 1-12.307 0Z",
    clipRule: "evenodd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    x: 0.5,
    y: 0.5,
    stroke: "#00CA72",
    rx: 27.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "instagram_svg__a",
    x1: 40.259,
    x2: 15.988,
    y1: 28.613,
    y2: 28.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CA72",
    stopOpacity: 0.2
  })))));
};
export default SvgInstagram;